import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CURRENT_INVOICE } from '../../GB_App/formSections/itemsTab/copyRepElement'
import { useEvent } from '../../hooks/useEvent'
import * as ActionTypes from '../actions/actionTypes'
import { SAVE_ITEM_ES } from '../api/apiEvents'

export const useMultipleMerchandiseItem = ({ tableName, fieldIdName, ...rest }) => {
  const { isLoading, saveForm, deleteForm } = useEvent('invoices', true)
  const dispatch = useDispatch()
   const invoiceList = useSelector((state) => state.InvoicesReducer.invoices) || []

  const AddItem = useCallback(
    async (param) => {
      try {
        const response = await saveForm(
          {
            invoiceId: rest.invoiceId,
            merchandises: [
              {
                merchandiseId: rest.merchandiseId,
                invoiceId: rest.invoiceId,
                [`${tableName}`]: [
                  {
                    merchandiseId: rest.merchandiseId,
                    ...param,
                  },
                ],
              },
            ],
          },
          true,
          SAVE_ITEM_ES
        )

        // console.log({ response })

        if (response) {
          const payload = response?.invoices[0]?.merchandises[0][`${tableName}`][0]
        //   console.log(payload)
          dispatch({
            type: ActionTypes.ADD_MERCHANDISE_DOC_BY_ID,
            payload: { ...payload, ...rest },
            meta: { tableName },
          })
        }
      } catch (e) {}
    },
    [rest.invoiceId, rest.merchandiseId]
  )

  const deleteItem = useCallback(
    async (id) => {
      try {
        const response = await deleteForm([
          {
            invoiceId: rest.invoiceId,
            merchandises: [
              {
                merchandiseId: rest.merchandiseId,
                invoiceId: rest.invoiceId,
                [`${tableName}`]: [
                  {
                    [`${fieldIdName}`]: id,
                    merchandiseId: rest.merchandiseId,
                  },
                ],
              },
            ],
          },
        ])
        if (response){
            if(tableName==='itemDuties'){
                let totalAmount = response?.invoices[0]?.merchandises[0]?.totalAmount
                dispatch({
                    type: ActionTypes.UPDATE_MERCHANDISE_AFTER_SAVE,
                    payload: { ...rest, totalAmount }
                  })
            }
            dispatch({
              type: ActionTypes.DELETE_MERCHANDISE_DOC_BY_ID,
              id,
              fieldIdName,
              payload: { ...rest },
              meta: { tableName: tableName },
            })
        }
      } catch (e) {}
    },
    [rest.invoiceId, rest.merchandiseId]
  )

  const updateItem = useCallback(
    (id, params) => {
      try {
        dispatch({
          type: ActionTypes.UPDATE_MERCHANDISE_DOC_BY_ID,
          id,
          fieldIdName,
          payload: { ...rest, ...params },
          meta: { tableName: tableName },
        })
      } catch (e) {
        console.log(e)
      }
    },
    [rest]
  )

  const saveItem = useCallback(
    async (payload) => {
     
      try {
        const response = await saveForm(
          {
            invoiceId: rest.invoiceId,
            merchandises: [
              {
                merchandiseId: rest.merchandiseId,
                invoiceId: rest.invoiceId,
                [`${tableName}`]: [
                  {
                    merchandiseId: rest.merchandiseId,
                    ...payload,
                  },
                ],
              },
            ],
          },
          false,
          SAVE_ITEM_ES
        )


        if(response && tableName === 'itemDuties'){
            let totalAmount = response?.invoices[0]?.merchandises[0]?.totalAmount
            dispatch({
                type: ActionTypes.UPDATE_MERCHANDISE_AFTER_SAVE,
                payload: { ...rest, totalAmount }
              })
        }


      } catch {}
    },
    [rest.invoiceId, rest.merchandiseId]
  )


  const AddcopyItem = useCallback(async(copyItemDetails) => {
    const {tabName, payload , ...restCopyItemDetails} = copyItemDetails
    try {
      const response = await saveForm({
          invoiceId: restCopyItemDetails.invoiceId,
          merchandises: [
            {merchandiseId: restCopyItemDetails?.merchandiseId,
              invoiceId: restCopyItemDetails?.invoiceId,
              [`${tabName}`]: [{ merchandiseId: restCopyItemDetails?.merchandiseId, ...payload }],
            }
          ],
        }, true,SAVE_ITEM_ES)
        
      if (response) {
        return response?.invoices[0]?.merchandises[0][`${tabName}`][0]
      }
    } catch (e) {}

 },[saveForm])

    const getPromiseList = useCallback((copyFor, payload) => {
        let multipleSaveRequest = null
        if(copyFor===CURRENT_INVOICE) {
            const merchandiseIds = invoiceList
            .find((inv) => inv.invoiceId === rest?.invoiceId)
            ?.merchandiseList?.filter(
              (merch) => merch?.merchandiseId !== rest?.merchandiseId
            ) || []
            multipleSaveRequest = merchandiseIds?.map((merch)=>AddcopyItem({
              tabName: tableName, 
              payload,
              invoiceId:merch?.invoiceId, 
              merchandiseId:merch.merchandiseId
            }))
        } else {
            const merchandiseIds = invoiceList.reduce((prev, curr) => {
              let merchList = [];
              if (curr?.invoiceId === rest?.invoiceId) {
                merchList = curr?.merchandiseList?.filter(
                  (merch) => merch?.merchandiseId !== rest?.merchandiseId
                );
              } else {
                merchList = curr?.merchandiseList;
              }
              return [...prev, ...merchList];
            }, []);
            multipleSaveRequest = merchandiseIds?.map((itm)=>AddcopyItem({
              tabName:tableName, 
              payload,
              invoiceId:itm?.invoiceId, 
              merchandiseId:itm?.merchandiseId
            }))       
        }
        return multipleSaveRequest
    },[invoiceList])

    const copyData = useCallback(async(copyFor, payload) => {
        const multipleSaveRequest = getPromiseList(copyFor, payload)
        let responseIds = await Promise.allSettled(multipleSaveRequest)
        responseIds = responseIds.filter(({status, value})=>status==='fulfilled' && value).map(({value})=>value)
        if(responseIds){
            dispatch({
                type: ActionTypes.MASS_UPDATE_REPEATABLE_ELEMENTS,            
                ids:responseIds,
                meta:{tableName}
            })
        }        
    },[invoiceList])

  return React.useMemo(
    () => ({
      AddItem,
      deleteItem,
      updateItem,
      saveItem,
      isLoading,
      copyData
    }),
    [AddItem, deleteItem, saveItem, updateItem, isLoading, copyData]
  )
}
